function initPlanningMobile() {
	$('.planning__nav ul li').click(function() {
		$('.planning__nav ul li').removeClass('day--current');
		$(this).addClass('day--current');
		var day = $(this).find('a').attr('data-day');
		console.log(day);

		$('.planning__table').removeClass('table--current');
		$(".planning__table[data-day=" + day + "]").addClass('table--current');
	});
}